import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBikes, adminListBookings } from "@/lib/api";
import { ArrowRight, Engine, EnvelopeSimple, FileText } from "@phosphor-icons/react";

export default function Overview() {
  const [bikesCount, setBikesCount] = useState(0);
  const [bookings, setBookings] = useState({ service_bookings: [], test_rides: [] });

  useEffect(() => {
    fetchBikes().then((b) => setBikesCount(b.length)).catch(() => {});
    adminListBookings().then(setBookings).catch(() => {});
  }, []);

  const tiles = [
    { label: "Μηχανές", value: bikesCount, icon: Engine, to: "/dashboard/bikes" },
    { label: "Ραντεβού Σέρβις", value: bookings.service_bookings.length, icon: EnvelopeSimple, to: "/dashboard/bookings" },
    { label: "Δοκιμές", value: bookings.test_rides.length, icon: EnvelopeSimple, to: "/dashboard/bookings" },
    { label: "Περιεχόμενο", value: "Επεξεργασία", icon: FileText, to: "/dashboard/content" },
  ];

  return (
    <div data-testid="dashboard-overview" className="space-y-10">
      <div>
        <p className="text-overline mb-3">Επισκόπηση</p>
        <h1 className="font-display font-black uppercase text-4xl md:text-5xl tracking-tight">Καλώς ήρθες πίσω.</h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {tiles.map((t, i) => (
          <Link
            key={i}
            to={t.to}
            data-testid={`overview-tile-${i}`}
            className="border border-white/10 bg-[#141414] p-6 hover:border-[#E50000]/60 transition-colors group"
          >
            <t.icon size={24} weight="duotone" className="text-[#E50000]" />
            <p className="mt-6 font-display text-3xl font-black">{t.value}</p>
            <p className="text-overline mt-1">{t.label}</p>
            <div className="mt-4 text-xs uppercase tracking-widest text-white/50 group-hover:text-white inline-flex items-center gap-2">
              Άνοιγμα <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Section title="Πρόσφατα Ραντεβού Σέρβις" items={bookings.service_bookings.slice(0, 5)} render={(b) => (
          <div>
            <p className="font-display text-base">{b.full_name} · {b.bike_brand} {b.bike_model}</p>
            <p className="text-xs text-white/50 font-mono mt-1">{b.preferred_date} · {b.service_type}</p>
          </div>
        )} />
        <Section title="Πρόσφατες Δοκιμές" items={bookings.test_rides.slice(0, 5)} render={(b) => (
          <div>
            <p className="font-display text-base">{b.full_name} · {b.bike_label}</p>
            <p className="text-xs text-white/50 font-mono mt-1">{b.preferred_date} · {b.license_years} χρ. δίπλωμα</p>
          </div>
        )} />
      </div>
    </div>
  );
}

function Section({ title, items, render }) {
  return (
    <div className="border border-white/10 bg-[#141414] p-6">
      <p className="text-overline mb-4">{title}</p>
      {items.length === 0 ? (
        <p className="text-white/40 text-sm">Καμία εγγραφή ακόμα.</p>
      ) : (
        <ul className="space-y-3">
          {items.map((b, i) => (
            <li key={i} className="border-l-2 border-[#E50000] pl-4 py-1">
              {render(b)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
